// src/search/constants.ts

export const NONE_VALUE = "__NONE__";
export const NO_STATUS_VALUE = NONE_VALUE;

export const PAGE_SIZE = 30;

export const RECENT_SEARCHES_KEY = ["recent-searches"];

/**
 * Status options for address notes.
 * Used in search filters and address detail forms.
 */
export const STATUS_OPTIONS = [
  { value: "INTERESTED", label: "Interested, needs quote" },
  { value: "REGULAR", label: "Agreed to regular clean" },
  { value: "CUSTOMER", label: "Already a customer" },
  { value: "LEAFLET", label: "Left leaflet" },
  { value: "CALLBACK", label: "Callback requested" },
  { value: "NOT_INTERESTED", label: "Not interested" },
  { value: "OBSERVED_DIRTY", label: "Observed dirty windows" },
  { value: "QUOTED", label: "Quoted" },
  { value: "EXCLUDE_LOW_DEM", label: "Excluded – Low Demographic" },
  { value: "EXCLUDE_ACCESS", label: "Exclude – Access Issues" },
  { value: "OTHER", label: "Other" },
] as const;

export type StatusValue = (typeof STATUS_OPTIONS)[number]["value"];

/**
 * Get the display label for a status value.
 */
export function getStatusLabel(value: string): string {
  const option = STATUS_OPTIONS.find((opt) => opt.value === value);
  return option?.label ?? value;
}
